import React from "react";
import EditIcon from "@mui/icons-material/EditOutlined";
import EyeIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CustomPopper } from "shared/organisms/popper/custom-popper";
import { Stack, Tooltip } from "@mui/material";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";

type ButtonProps = {
  handleEdit?: () => void;
  handleCopy?: () => void;
  hideDeleteIcon:Boolean;
  hideCopyIcon:Boolean;
  hideEditIcon:Boolean;
  hidePreviewIcon:Boolean;
  handleDelete?: () => void;
  handlePreview?: () => void;
};

export const ActionButtons = (props: ButtonProps) => {
  const { handleEdit,hideEditIcon, handleCopy,hideDeleteIcon,handleDelete,hideCopyIcon,handlePreview,hidePreviewIcon } = props;
  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      sx={{ cursor: "pointer" }}
    >
      {hideCopyIcon !== true &&
        (<Tooltip title="Duplicate Delivery">
          <ContentCopyIcon onClick={handleCopy} />
        </Tooltip>)
      }
      {hideEditIcon !== true &&
        (<Tooltip title="Edit Delivery">
          <EditIcon onClick={handleEdit} />
        </Tooltip>)
      }
      {hidePreviewIcon !== true &&
        (<Tooltip title="Preview">
          <PreviewOutlinedIcon onClick={handlePreview} />
        </Tooltip>)
      }
       {hideDeleteIcon !== true && (
        <CustomPopper onAgree={handleDelete} sx={{}}>
          <Tooltip title="Delete">
            <DeleteIcon />
          </Tooltip>
        </CustomPopper>
      )}
    </Stack>
  );
};
